import ListMarkings from "../../../../components/@users/customers/ListMarkings";

import { routeTypes } from "../../../../../../hooks/useSystemRoutes";

export default function MarkingsPage() {
    
    return (
        <ListMarkings 
            routeType={routeTypes.admin}
        />
    )
}       